import HttpRequest from "./HttpRequest"

export class HttpDataSource {

    constructor(url, size) {
    //  super()
      this.url = url
      this.size = size
    }

    fetchChunk(startOffset, endOffset) {
        // The endOffset is  *exclusive* while range request end
        return HttpRequest.sendRangeRequest(this.url, startOffset, endOffset - 1);
    }

    /**
     * Get the size of the data in bytes.
     */
    getSize() {
        return this.size;
    }
}
